const buildByteArray = (string, stringLength) => {
  const buffer = new ArrayBuffer(stringLength);
  const array = new Uint8Array(buffer);
  for (let i = 0; i < stringLength; i++) {
    array[i] = string.charCodeAt(i);
  }
  return array;
};

export default buildByteArray;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/buildByteArray.js